
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";
import { Head } from "@/components/Head";
import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { CTASection } from "@/sections/CTASection";

const XdToCanva = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/XDToCanva"
        ogImage="/images/xd2canva-og-image.jpg"
      />

      <MagicianSection
        title={t("page/XDToCanva:title")}
        subtitle={t("page/XDToCanva:subtitle")}
        magicianLogoFile="canva"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ConvertEverythingSection",
        }}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/XDToCanva:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/xd-to-canva-converter-example.png",
          alt: "Xd to Canva converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/XDToCanva:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/XDToCanva:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/xd-to-canva-converted-file-elements.jpg",
          alt: t("page/XDToCanva:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/XDToCanva:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/XDToCanva:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/XDToCanva:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/XDToCanva:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/XDToCanva:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "IMAGE-RED-ICON",
            title: t(
              "page/XDToCanva:section/shareDesign.elements.imageSupportTitle",
            ),
            text: t(
              "page/XDToCanva:section/shareDesign.elements.imageSupportText",
            ),
          },
        ]}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />
      <CTASection
        title={t("section/cta:titles.xdToCanvaPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default XdToCanva;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/xd-to-canva',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  